<template>
  <div class="stats-card">
    <div class="card-header">
      <div class="icon-container">
        <slot name="icon"></slot>
      </div>
      <div class="stats">
        <div class="primary-block">
          <span class="number" v-text="stat.toString()" />
        </div>
      </div>
    </div>
    <div>
      <span class="label" v-text="label" />
    </div>
  </div>
</template>

<style lang="scss" scoped>

  .stats-card {
    gap: 8px;
    //flex-direction: column;
    align-items: center;
    padding: 24px;

    .label {
      font-size: 15px;
    }
  }

  .card-header {
    display: flex;
    flex-direction: row;
    gap: 8px;
  }

  .icon-container {
    width: 35px !important;
    height: 35px !important;
  }

  .stats {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .number {
      font-size: 22px !important;
    }
  }

</style>

<script setup>
defineProps({
  stat: {
    type: Number,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});
</script>